module.exports = __webpack_public_path__ + "img/bingo_ball-31.0712644f.png";